import React from "react";
import ProductCard from "../../../../ecommerce/globalcomponents/product/ProductCard";
import { Product } from "../../../../Redux/ecommersProduct/types";

interface SubCategorieProductsProps {
  products: Product[];
  loading: boolean;
  error: string | null;
}

const SubCategorieProducts: React.FC<SubCategorieProductsProps> = ({
  products,
  loading,
  error,
}) => {
  if (loading && products.length === 0) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <div className="spinner-border text-yellow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error && products.length === 0) {
    return (
      <div className="alert alert-danger m-3" role="alert">
        {error}
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="text-center py-5">
        <h4>No products found matching your criteria.</h4>
        <p className="text-muted">Try adjusting your filters.</p>
      </div>
    );
  }

  return (
    <>
      <div className="display-max">
        <div className="card p-3 mb-4 shadow-sm">
          <img
            className="border-radius-0"
            src="https://t3.ftcdn.net/jpg/06/36/44/26/360_F_636442646_II8z4yhYbPoea8P6HoimUblo6ZQXzUXY.jpg"
            alt="Promotion Banner"
            style={{ width: "100%", height: "auto" }}
          />
        </div>

        <div className="row mx-0">
          {products.slice(0, 12).map((product) => (
            <ProductCard key={product._id} product={product} />
          ))}
        </div>

        {products.length > 12 && (
          <>
            <div className="card p-3 my-4 shadow-sm">
              <img
                className="border-radius-0"
                src="https://t4.ftcdn.net/jpg/03/67/56/73/360_F_367567354_JnT96QOWu8rugfLdYaESxWkqaIOUja8t.jpg"
                alt="Secondary Banner"
                style={{ width: "100%", height: "auto" }}
              />
            </div>
            <div className="row mx-0">
              {products.slice(12).map((product) => (
                <ProductCard key={product._id} product={product} />
              ))}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default SubCategorieProducts;
